import React, { useState, useEffect, useRef } from "react";
import InputText from "../ReusableComponents/InputText";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import TextArea from "../ReusableComponents/TextArea";
import MainLayout from "../components/MainLayout";
import Loader from "../ReusableComponents/Loader";
import GridPage from "../components/GridPage";
import { mainTable } from "../css/Common";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import PopUpButtons from "../components/PopUpButtons";
import MaintenancePopup from "../popup-containers/MaintenancePopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { format } from "date-fns";
import DropDown from "../ReusableComponents/DropDown";
import { maintenanceHeader } from "../components/HeaderAttribute";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Maintenance = () => {
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [popUpDataDD, setPopUpDataDD] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [txnMaintenanceId, setTxnMaintenanceId] = useState("");
  const [selectedFile, setselectedFile] = useState([]);
  const [allRooms, setAllRooms] = useState([]);

  const API_BASE_URL = window.location.protocol === "https:" ? "https" : "http";
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);

  const [showImage, setShowImage] = useState("");
  const [showImageError, setShowImageError] = useState("");

  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const [rowIndex, setRowIndex] = useState(null);

  const handleShowImage = (showImage) => {
    console.log("image", showImage);
    setFormFields({
      ...formFields,
      fileUploaded: showImage || "",
    });

    setFormFieldsError({ ...formFieldsError, fileUploaded: "" });
  };

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setImageDisabled(false);
    setFileDisabled(true);

    const file = event.target.files[0];
    if (!file) return;

    if (!isFileFormatAllowed(file)) {
      toast.error(`Unsupported file format: ${file.name}`);
      return;
    }

    if (!isFileSizeBelowLimit(file)) {
      toast.error(`File size exceeds the limit`);
      return;
    }

    if (
      selectedFile.length > 0 &&
      selectedFile[0].file.name === file.name &&
      selectedFile[0].file.size === file.size
    ) {
      toast.error("This file is already selected");
      return;
    }

    setselectedFile([
      {
        file,
        previewUrl: URL.createObjectURL(file),
      },
    ]);
  };

  const handleImageCancel = (index) => {
    setImageDisabled(true);
    setFileDisabled(false);
    const updatedTableData = [...selectedFile];
    updatedTableData.splice(index, 1);
    setselectedFile(updatedTableData);
    const formData = new FormData();
    const imageUrlArray = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      imageUrlArray.push(updatedTableData[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setShowImage(imageUrlString);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clears the file input value
    }
  };

  const [formFields, setFormFields] = useState({
    date: "",
    spaces: "",
    room: "",
    fixedAsset: "",
    issueType: "",
    amount: "",
    fileUploaded: "",
    remarks: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    dateError: "",
    spacesError: "",
    roomError: "",
    fixedAssetError: "",
    issueTypeError: "",
    amountError: "",
    fileUploaded: "",
    remarksError: "",
  });

  var mstClientId = sessionStorage.getItem("MstClientId");
  const createdBy = sessionStorage.getItem("createdBy");
  const [bindRoomType, setBindRoomType] = useState([]);
  const [bindRoom, setBindRoom] = useState([]);
  const [bindFixedAsset, setBindFixedAsset] = useState([]);
  const [bindIssueType, setBindIssueType] = useState([]);
  const [bindMaintenance, setBindMaintenanceData] = useState([]);

  useEffect(() => {
    BindMaintenance();
  }, []);

  useEffect(() => {
    if (formFields.spaces) {
      const filteredRooms = allRooms.filter(
        (room) => room.roomTypeId === formFields.spaces
      );
      setBindRoom(filteredRooms);
    } else {
      setBindRoom([]);
    }
  }, [formFields.spaces, allRooms]);

  const BindMaintenance = async () => {
    setIsLoading(true);
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "MaintenanceAPI/BindMaintenance");
    if (response && response.data) {
      setBindMaintenanceData(response.data.Table);

      console.log("Bind Maintenance", response);

      const RoomTypeData = response.data.Table1.map((item) => ({
        value: item.MstRoomTypeId,
        label: item.RoomType,
      }));
      const RoomData = response.data.Table2.map((item) => ({
        value: item.MstRoomMasterId,
        label: item.RoomName,
        roomTypeId: item.MstRoomTypeId,
      }));

      setAllRooms(RoomData);
      setBindRoom([]);
      const CommodityCategory = response.data.Table3.map((item) => ({
        value: item.MstItemcategoryId,
        label: item.ItemCategory,
      }));

      const IssueType = response.data.Table4.map((item) => ({
        value: item.MstIssuesTypeId,
        label: item.IssuesType,
      }));

      setBindRoomType(RoomTypeData);
      setBindRoom(RoomData);
      setBindFixedAsset(CommodityCategory);
      setBindIssueType(IssueType);
    } else {
      setBindRoomType([]);
      setBindRoom([]);
      setBindFixedAsset([]);
      setBindIssueType([]);
    }
    setIsLoading(false);
  };

const validateForm = () => {
  const errors = {};

  if (!formFields.date) errors.dateError = "Date is required";
  if (!formFields.spaces) errors.spacesError = "Select Room Type";
  if (!formFields.room) errors.roomError = "Select Room";
  if (!formFields.fixedAsset) errors.fixedAssetError = "Select Fixed Asset";
  if (!formFields.issueType) errors.issueTypeError = "Select Issue Type";

  if (!formFields.amount) {
    errors.amountError = "Enter amount";
  } else if (!/^\d+(\.\d{1,2})?$/.test(formFields.amount)) {
    errors.amountError = "Enter valid amount";
  }

  // ✅ FILE UPLOAD VALIDATION
  if (
    !formFields.fileUploaded ||
    (typeof formFields.fileUploaded === "string" &&
      formFields.fileUploaded.trim() === "")
  ) {
    errors.fileUploaded = "Please upload file";
  }

  setFormFieldsError(errors);
  return Object.keys(errors).length === 0;
};

  const handleSubmit = async (rowIndex, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();

    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          txnMaintenanceId: txnMaintenanceId ? txnMaintenanceId : 0,
          mstClientId: mstClientId,
          date: formFields.date,
          mstRoomTypeId: formFields.spaces,
          mstRoomId: formFields.room,
          mstFixedAssetId: formFields.fixedAsset,
          mstIssueTypeId: formFields.issueType,
          amount: formFields.amount,
          remarks: formFields.remarks,
          fileUpload: formFields.fileUploaded ?? "",
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "MaintenanceAPI/IUDMaintenance");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      }
    } else {
      const data = {
        txnMaintenanceId: txnMaintenanceId ? txnMaintenanceId : 0,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "MaintenanceAPI/IUDMaintenance");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete data. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error(" Data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  const handleEdit = (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setTxnMaintenanceId(bindMaintenance[rowIndex].TxnMaintenanceId);
    const formatted = bindMaintenance[rowIndex]?.Date
      ? format(new Date(bindMaintenance[rowIndex].Date), "yyyy-MM-dd")
      : "";
    setFormFields({
      ...formFields,
      date: formatted,
      spaces: bindMaintenance[rowIndex].MstRoomTypeId,
      room: bindMaintenance[rowIndex].MstRoomId,
      fixedAsset: bindMaintenance[rowIndex].MstFixedAssetId,
      issueType: bindMaintenance[rowIndex].MstIssueTypeId,
      amount: bindMaintenance[rowIndex].Amount,
      remarks: bindMaintenance[rowIndex].Remarks,
      fileUploaded: bindMaintenance[rowIndex].FileUpload,
    });
  };

  const handleMaintenance = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    const rowData = bindMaintenance[rowIndex];
    if (!rowData) return;
    setTxnMaintenanceId(rowData.TxnMaintenanceId);
    setPopUpData(rowData);
    setPopUpDataDD(bindMaintenance);
  };

const handleBlur = (name) => {
  setFormFieldsError((prev) => {
    let error = "";

    if (!formFields[name]) {
      switch (name) {
        case "date":
          error = "Date is required";
          break;
        case "spaces":
          error = "Select Room Type";
          break;
        case "room":
          error = "Select Room";
          break;
        case "fixedAsset":
          error = "Select Fixed Asset";
          break;
        case "issueType":
          error = "Select Issue Type";
          break;
        default:
          error = "This field is required";
      }
    }

    return {
      ...prev,
      [`${name}Error`]: error,
    };
  });
};


  const showAdd = () => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleAdd(true);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setFormFields({
      date: "",
      spaces: "",
      room: "",
      fixedAsset: "",
      issueType: "",
      amount: "",
      fileUploaded: "",
      remarks: "",
    });
  };

  const cancel = () => {
    BindMaintenance();
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setVisibleAdd(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    setFormFieldsError({
      dateError: "",
      spacesError: "",
      roomError: "",
      fixedAssetError: "",
      issueTypeError: "",
      amountError: "",
      fileUploaded: "",
      remarksError: "",
    });
    setFormFields({
      date: "",
      spaces: "",
      room: "",
      fixedAsset: "",
      issueType: "",
      amount: "",
      fileUploaded: "",
      remarks: "",
    });
    setpopUpOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // const handleAutoDropdownChange = (value, name) => {
  //   setFormFields((prevFields) => ({
  //     ...prevFields,
  //     [name]: value,
  //   }));
  // };

  const handleAutoDropdownChange = (value, name) => {
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "spaces" && { room: "" }),
    }));
  };
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {visibleTable && (
        <GridPage
          title="Maintenance"
          header={maintenanceHeader}
          records={bindMaintenance}
          blockView={true}
          handleAction={handleMaintenance}
          handleEdit={handleEdit}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.clientMaintenanceReportAdd}>
            <AddScreenTitle
              title="Maintenance"
              updateScreenTitle={updateScreenTitle}
              addScreenTitle={addScreenTitle}
            />
          </div>

          <div className={mainTable.mainContentScreen}>
            <div className={mainTable.grid3}>
              <InputText
                inputType="date"
                title="Date"
                name="date"
                classStar="text-red-500"
                content={formFields.date}
                controlFunc={(e) =>
                  setFormFields((prev) => ({
                    ...prev,
                    date: e.target.value,
                  }))
                }
                controlFuncBlur={() => handleBlur("date")}
                errorMessage={formFieldsError.dateError}
              />

              <AutoDropDown
                title="Room Type"
                name="spaces"
                classStar={"text-red-500"}
                options={bindRoomType}
                selectedOption={bindRoomType.find(
                  (x) => x.value == formFields.spaces
                )}
                controlFunc={(value) =>
                  setFormFields((prev) => ({
                    ...prev,
                    spaces: value?.value ?? null,
                  }))
                }
                controlFuncBlur={() => handleBlur("spaces")}
                errorMessage={formFieldsError.spacesError}
                Class="custom-class"
              />

              <AutoDropDown
                title="Room"
                name="room"
                Class="custom-class"
                classStar={"text-red-500"}
                options={bindRoom}
                selectedOption={bindRoom.find(
                  (x) => x.value == formFields.room
                )}
                controlFunc={(value) =>
                  setFormFields((prev) => ({
                    ...prev,
                    room: value?.value ?? null,
                  }))
                }
                controlFuncBlur={() => handleBlur("room")}
                errorMessage={formFieldsError.roomError}
              />

              <AutoDropDown
                title="Fixed Asset"
                name="fixedAsset"
                classStar={"text-red-500"}
                Class="custom-class"
                options={bindFixedAsset}
                selectedOption={bindFixedAsset.find(
                  (x) => x.value == formFields.fixedAsset
                )}
                controlFunc={(value) =>
                  setFormFields((prev) => ({
                    ...prev,
                    fixedAsset: value?.value ?? null,
                  }))
                }
                controlFuncBlur={() => handleBlur("fixedAsset")}
                errorMessage={formFieldsError.fixedAssetError}
              />

              <AutoDropDown
                title="Issue Type"
                name="issueType"
                Class="custom-class"
                classStar={"text-red-500"}
                options={bindIssueType}
                selectedOption={bindIssueType.find(
                  (x) => x.value == formFields.issueType
                )}
                controlFunc={(value) =>
                  setFormFields((prev) => ({
                    ...prev,
                    issueType: value?.value ?? null,
                  }))
                }
                controlFuncBlur={() => handleBlur("issueType")}
                errorMessage={formFieldsError.issueTypeError}
              />

              <InputText
                inputType="text"
                title="Amount"
                classStar={"text-red-500"}
                name="amount"
                content={formFields.amount}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const isValid = /^\d+(\.\d{1,2})?$/.test(formFields.amount);
                  setFormFieldsError((prev) => ({
                    ...prev,
                    amountError: !formFields.amount
                      ? "Enter amount"
                      : !isValid
                      ? "Enter valid amount"
                      : "",
                  }));
                }}
                errorMessage={formFieldsError.amountError}
              />

              <div className="col-span-3">
                {/* <FileUpload
                                    title="Upload File "
                                    //   classStar="text-red-500"
                                    apiCall="MaintenanceAPI/MaintenanceImageUpload"
                                    modalName="MaintenanceImages"
                                    name="showImage"
                                    disabledBtn={updateScreenTitle}
                                    showImage={formFields.fileUploaded}
                                    showImageData={handleShowImage}
                                    imageUploadedError={formFieldsError.fileUploaded}
                                    limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                                    MAX_FILE_SIZE_MB={2}
                                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                                /> */}

                <FileUpload
                  title="Upload File"
                  classStar="text-red-500"
                  apiCall="MaintenanceAPI/MaintenanceImageUpload"
                  modalName="MaintenanceImages"
                  name="showImage"
                  disabledBtn={updateScreenTitle}
                  showImage={formFields.fileUploaded}
                  showImageData={handleShowImage}
                  imageUploadedError={formFieldsError.fileUploaded}
                  limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                  MAX_FILE_SIZE_MB={2}
                  ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                />

                <TextArea
                  title="Remarks"
                  name="remarks"
                  content={formFields.remarks}
                  controlFunc={handleInputChange}
                  rows={3}
                />
              </div>
            </div>
          </div>

          <div className="col-span-2 flex justify-center gap-4 mt-4">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              handleSubmit={handleSubmit}
              cancel={cancel}
              disabledBtn={false}
              viewSaveButton={false}
            />
          </div>
        </div>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleMaintenance}
      >
        <div>
          <PopUpScreenTitle
            title="Maintenance"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <MaintenancePopup data={popUpData} data1={popUpDataDD} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          viewDetails={viewDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Maintenance;
